import { createPluginFactory } from '@udecode/plate';

export const TYPING_INDICATOR = 'typing-indicator';

export default function createTypingIndicatorPlugin(onChange) {
  const p = createPluginFactory({
    key: TYPING_INDICATOR,

    handlers: {
      onChange: editor => children => {
        onChange(children);
      },
    },
  });
  return p();
}
